import styled from '@emotion/styled';
import { TOKEN_SCOPE, useServiceAppState } from '@kc-console/context';
import { np } from '@kc-console/core';

import { MediaQuery } from '../../../constants';
import DomainInfoMenu from './DomainInfoMenu';
import GnbDivider from './GnbDivider';
import GnbMenuItem from './GnbMenuItem';
import Logo from './Logo';
import ProjectMenu from './ProjectMenu';

const GnbLeftSideComponent = () => {
  const {
    state: { scope },
  } = useServiceAppState();
  const isProjectScope = scope === TOKEN_SCOPE.PROJECT;
  return (
    <GnbLeftContainer isProjectScope={isProjectScope}>
      <Logo />
      <GnbDivider />
      {isProjectScope ? <ProjectMenu /> : <DomainInfoMenu />}
    </GnbLeftContainer>
  );
};

export default GnbLeftSideComponent;

const GnbLeftContainer = styled(GnbMenuItem, { shouldForwardProp: np('isProjectScope') })<{
  isProjectScope: boolean;
}>`
  ${MediaQuery.TIL_MEDIUM} {
    max-width: 354px;
    width: 100%;
  }
  ${MediaQuery.LARGE} {
    width: 354px;
  }
`;
